import React, { useState, useRef, useEffect } from 'react';

const BRAND = '#0052CC';

/**
 * Single "Export Data" control — one button, chevron inside, options revealed
 * on click. Collapsed by default.
 */
export default function ExportDropdown({
  options,          // [{ label, sublabel?, onClick }]
  disabled = false,
  disabledHint = '',
  loading = false,
  fullWidth = false,
  align = 'right',  // dropdown alignment: 'right' | 'left'
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    function handleClick(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  // Close if the control becomes disabled while open
  useEffect(() => {
    if (disabled) setOpen(false);
  }, [disabled]);

  return (
    <div
      ref={ref}
      style={{ position: 'relative', width: fullWidth ? '100%' : 'auto' }}
    >
      <button
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
          width: fullWidth ? '100%' : 'auto',
          padding: '10px 18px',
          borderRadius: '8px',
          border: `1px solid ${BRAND}`,
          backgroundColor: '#fff',
          color: BRAND,
          fontSize: '13px',
          fontWeight: '600',
          fontFamily: 'inherit',
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.45 : 1,
          whiteSpace: 'nowrap',
          transition: 'background-color 0.15s',
        }}
        onClick={() => { if (!disabled && !loading) setOpen(o => !o); }}
        disabled={disabled || loading}
        title={disabled ? disabledHint : undefined}
        onMouseEnter={e => { if (!disabled) e.currentTarget.style.backgroundColor = '#EBF5FF'; }}
        onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#fff'; }}
      >
        {loading ? 'Preparing export…' : 'Export Data'}
        {!loading && (
          <span style={{ fontSize: '10px', lineHeight: 1 }}>{open ? '▲' : '▼'}</span>
        )}
      </button>

      {open && !disabled && (
        <div
          style={{
            position: 'absolute',
            top: '46px',
            [align]: 0,
            backgroundColor: '#fff',
            borderRadius: '10px',
            border: '1px solid #e5e7eb',
            boxShadow: '0 8px 28px rgba(0,0,0,0.14)',
            minWidth: '250px',
            zIndex: 200,
            overflow: 'hidden',
            padding: '4px 0',
          }}
        >
          {options.map((opt, i) => (
            <button
              key={i}
              style={{
                display: 'block',
                width: '100%',
                padding: '11px 16px',
                border: 'none',
                background: 'none',
                textAlign: 'left',
                cursor: 'pointer',
                fontFamily: 'inherit',
                fontSize: '13px',
                fontWeight: '600',
                color: '#374151',
              }}
              onClick={() => { setOpen(false); opt.onClick(); }}
              onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#f9fafb'; }}
              onMouseLeave={e => { e.currentTarget.style.backgroundColor = 'transparent'; }}
            >
              {opt.label}
              {opt.sublabel && (
                <div style={{ fontSize: '11px', color: '#9ca3af', fontWeight: '400', marginTop: '2px' }}>
                  {opt.sublabel}
                </div>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
